











import Vue from 'vue'

export default Vue.extend({
  name: 'QuickAddButton',

  props: {
    title: {
      type: String,
      default: 'Add New',
    },
    size: {
      type: String,
      default: 'tiny',
    },
    color: {
      type: String,
      default: 'grey',
    },
  },
})
